import { Button } from 'components/ui';
import { useMutation } from '@apollo/client/react';
import { useModal } from 'contexts/modal';
import { useInfo } from 'contexts/info';
import { useError } from 'contexts/error';
import { FormattedMessage } from 'react-intl';
import ModalEnable2fa from 'components/user/profile/modal/two_factor/enable';
import QrCodeMutation from 'mutations/user/two_factor/qr_code';

const EnableTwoFactorModal = ({ refetch }) => {
  const { addModal, removeModal } = useModal();
  const setError = useError();
  const setInfo = useInfo();

  const [getQrCodeMutation] = useMutation(QrCodeMutation, {
    onCompleted: ({ userSetupTwoFactor }) => {
      addModal(
        <ModalEnable2fa
          qrCode={userSetupTwoFactor.qrCode}
          secret={userSetupTwoFactor.secret}
          onSuccess={() => {
            refetch();
            removeModal();
            setInfo('info.user.two_factor.enabled');
          }}
          handleClose={() => {
            removeModal();
          }}
        />,
        { disableAutoFocus: true, disableRestoreFocus: true }
      );
    },
    onError: () => {
      setError('error.user.two_factor.enable');
    },
  });

  return (
    <Button className="no-wrap" variant="outlined" onClick={getQrCodeMutation}>
      <FormattedMessage id="button.two_factor.enable" />
    </Button>
  );
};

export default EnableTwoFactorModal;
